import { TPayMethod } from "../../types/TPayMethod";
import config from "../config/config";
import httpService from "../http/HttpService";

const PROMO_CODES_URL = `${config.apiUrl}/promocodes`;

interface IBuyPromoCodeRequest {
  phone?: string;
  months: number;
  amountTotal: number;
  price: number;
  isCorporate: boolean;
  method: TPayMethod;
  text?: string;
  discount?: number;
  discountCorporation?: number;
  companyName?: string,
  inn?: string,
  workPhone?: string,
  legalAddress?: string
}

interface IBuyPromoCodeResponse {
  id: number;
  text: string;
  amountTotal: number;
  amountLeft: number;
  months: number;
  price: number;
  phone: string;
  method: string;
  isCorporate: boolean;
  creationDate: string;
  paymentDate: string;
}

class BuySubscriptionApi {
  async createSubscription(data: IBuyPromoCodeRequest): Promise<IBuyPromoCodeResponse | null> {
    const response = await httpService.post(`${PROMO_CODES_URL}/buy/binding`, data);
    return response.success ? response.data as IBuyPromoCodeResponse : null;
  }
}

export default BuySubscriptionApi;
